import React from 'react';
import { Form, Input } from 'antd';

const { TextArea } = Input;

const TeamComment = ({ value, onChange, placeholder = "Введите комментарий для команды" }) => (
    <Form.Item label="Комментарий для команды">
        <TextArea
            value={value}
            onChange={onChange}
            rows={4}
            placeholder={placeholder}
        />
    </Form.Item>
);

export default TeamComment;